import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CHANGE_LANGUAGE } from 'app/shared/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'resend-code',
    templateUrl: './resend-code.component.html',
    styleUrls: ['./resend-code.component.scss'],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
    imports: [
        InputGeneralComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        TranslateModule,
        RouterModule,
        InputGeneralComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
    ],
    standalone: true,
})
export class ResendCodeComponent implements OnInit {
    confirmSignUpForm: FormGroup;
    submitted = false;
    isOTPNumeric = true;
    userObj;
    countdown: number = 60; // Set the initial countdown value (in seconds)
    interval: any;
    disableVerify:boolean = false;
    showCountdown = true;
    resendCode = false;
    isRequired;
    digitOnlyError;
    errMsg: string;
    closeTostr: string;
    current_url: any;
    calendarEventURL = '';
    brpSourceUrl = '';
    selectedLanguage: any;
    expiredCodeExceptionErrMsg: any;

    constructor(
        private authService: AuthService,
        private fb: FormBuilder,
        private router: Router,
        public translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
    ) {
        this.userObj =
            this.router.getCurrentNavigation().extras.state?.userDetails;

        if (!this.userObj || this.userObj == undefined) {
            this.router.navigate(['/sign-up']);
        }
    }

    ngOnInit() {
        this.selectedLanguage = localStorage.getItem('language');
        this.confirmSignUpForm = this.fb.group({
            confirmationCode: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]+$/)],
            ],
        });

        this._translate();
        this.startCountdown();

        // assigning returnUrl flag for redirection
        this.activatedRoute.queryParams.subscribe((params) => {
            this.calendarEventURL = params.calendarEventURL;
            this.brpSourceUrl = params.brpSourceUrl;
        });
    }

    private _translate() {
        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });

        this.translate.get('ERROR.DIGIT_ONLY').subscribe((data: any) => {
            this.digitOnlyError = data;
        });

        this.translate
            .get('ERROR.SOMETHING_WENT_WRONG')
            .subscribe((data: any) => {
                this.errMsg = data;
            });

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate.get('ERROR.CODE_EXPIRED_ERR').subscribe((data: any) => {
            this.expiredCodeExceptionErrMsg = data;
        });
    }

    get f() {
        return this.confirmSignUpForm.controls;
    }

    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];

        if (this.f[input].touched || this.submitted) {
            if (this.f[input].errors?.required) {
                errors.push(inputName + ' ' + this.isRequired);
            }
            if (!this.f[input].value.match(/^[0-9]+$/)) {
                errors.push(inputName + ' ' + this.digitOnlyError);
            }
        }

        return errors;
    }

    startCountdown() {
        this.interval = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
                this.showCountdown = true;
            } else {
                clearInterval(this.interval);
                this.showCountdown = false;
            }
        }, 1000); // Update the countdown every 1 second (1000 ms)
    }

    onResendCode() {
        this.countdown = 60;
        this.showCountdown = true;
        this.startCountdown();

        let resendDetails = {
            username: this.userObj?.username,
        };

        this.authService.resendSignUpEmail(resendDetails).subscribe({
            next: () => {
                this.disableVerify = false;
            },
            error: (err) => {
                this.toastr.error(err?.error?.message);
            },
        });
    }

    onConfirmDetails() {
        this.submitted = true;
        const confirmationDetails = {
            username: this.userObj?.username,
            confirmationCode: this.confirmSignUpForm.value.confirmationCode,
        };

        if (this.confirmSignUpForm.valid) {
            this.disableVerify = true;
            this.authService.confirmUserSignUp(confirmationDetails).subscribe({
                next: () => {
                    const navigationExtras = {
                        state: { result: 'done', isRegistered: true },
                    };
                    if (this.calendarEventURL)
                        navigationExtras['queryParams'] = {
                            calendarEventURL: this.calendarEventURL,
                        };
                    else if (this.brpSourceUrl) {
                        navigationExtras['queryParams'] = {
                            brpSourceUrl: this.brpSourceUrl,
                        };
                    }
                    this.router.navigate(['/sign-up-status'], navigationExtras);
                },
                error: (err) => {
                    this.disableVerify = false;
                    let errorMsg = err?.error?.message;
                    let errReason = err?.error?.reason;

                    this.translate.get(errReason).subscribe((data: any) => {
                        if (data !== errReason) {
                            errorMsg = data;
                        } else if (errReason === 'ExpiredCodeException') {
                            errorMsg = this.expiredCodeExceptionErrMsg;
                        } else {
                            errorMsg = this.errMsg;
                        }
                    });

                    this.toastr.error(errorMsg);
                },
            });
        }
    }

    switchLanguage(language: string) {
        CHANGE_LANGUAGE(language, this.router.url, this.translate);
        this._translate();
    }
}
